import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-listmenu',
  templateUrl: './listmenu.component.html',
  styleUrls: ['./listmenu.component.css']
})
export class ListmenuComponent implements OnInit {
  @Output() sidenavClose = new EventEmitter();
  //public links = [{link: 'Inicio', fragment: 'inicio'}, {link: 'El Proceso', fragment: 'proceso'}, {link: 'Historia', fragment: 'historia'}, {link: 'Comprar', fragment: 'comprar'}, {link: 'Seamos Amigos', fragment: 'amigos'}, {link: 'Paquetes', fragment: 'paquetes'}, {link: 'Contacto', fragment: 'contacto'}]
  public links = [{link: 'Inicio', fragment: 'inicio'}, {link: 'El Proceso', fragment: 'proceso'}, {link: 'Historia', fragment: 'historia'}, {link: 'Comprar', fragment: 'comprar'}, {link: 'Seamos Amigos', fragment: 'amigos'}, {link: 'Contacto', fragment: 'contacto'}]
  public active: number = 0;
  constructor() { }

  ngOnInit(): void {
  }

  public onSidenavClose = () => {
    this.sidenavClose.emit();
    document.body.scrollTop = 0; // Safari
    document.documentElement.scrollTop = 0; // Other
  }
}
